import { selectObjectTypesList } from 'slices/objectTypes.slice';
import { useAppSelector } from 'slices/store';
import type { FormInstance } from '@timeedit/ui-components/antd';
import BulkEditAssociation from './BulkEditAssociation';
import type { BulkEditAction } from './common';

type Props = {
  action: BulkEditAction;
  form: FormInstance;
};

const BulkEditOptionalRelations = ({ action, form }: Props) => {
  const objectTypes = useAppSelector(selectObjectTypesList);

  return (
    <BulkEditAssociation
      action={action}
      form={form}
      objectTypes={objectTypes}
      relationType="optionalRelations"
    />
  );
};

export default BulkEditOptionalRelations;
